import { render, staticRenderFns } from "./Debugger.vue?vue&type=template&id=24c07078&scoped=true"
import script from "./Debugger.vue?vue&type=script&lang=js"
export * from "./Debugger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c07078",
  null
  
)

export default component.exports